<template>
  <Layout>
    <b-row class="pb-4 pt-2">
      <b-col md="5">
        <Button location="title" type="white" @click="cancel()">Voltar</Button>
      </b-col>
      <b-col md="3">
        <h1 class="title">{{ this.osObject.id ? 'Editar' : 'Novo' }} Objeto</h1>
      </b-col>
    </b-row>
    <Form>
      <Tabs :menus="panelMenus">
        <template v-slot:0>
          <div>
            <b-row class="align-items-end">
              <b-col md="9">
                <Input
                  id="description"
                  label="Descrição"
                  labelBold
                  :maxlength="30"
                  :error="$v.osObject.description.$error"
                  v-model="osObject.description"
                />
              </b-col>
              <b-col lg="3" class="text-center">
                <b-col><Label>Ativo</Label></b-col>
                <b-row>
                  <b-col>
                    <CheckboxSwitch
                      id="active"
                      :tooltipPosition="'bottom'"
                      v-model="osObject.active"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </template>
      </Tabs>
      <FooterForm @cancel="cancel" @submit="save" />
    </Form>
  </Layout>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {
  Layout,
  Button,
  Tabs,
  Input,
  CheckboxSwitch,
  Label,
} from '@/components';
import { Form, FooterForm } from '@/components/Form';
import { required, getIdByLastSlash } from '@/reusable';

export default {
  name: 'ServiceOrderObjectsForm',
  components: {
    Input,
    Layout,
    Button,
    Form,
    Label,
    FooterForm,
    Tabs,
    CheckboxSwitch,
  },
  validations: {
    osObject: {
      description: { required },
    },
  },
  data() {
    return {
      panelMenus: [{ id: 0, label: 'Geral' }],
    };
  },
  async mounted() {
    this.setLoading(true);
    const id = getIdByLastSlash(this.$route.fullPath);

    if (!id) return this.setLoading(false);

    try {
      await this.setDetailedOsObject(id);
    } catch (error) {
      this.$router.push({ name: 'ServiceOrderObjectsRegister' });
    }

    return this.setLoading(false);
  },
  computed: {
    ...mapState('osObjects', ['osObject']),
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    ...mapActions('osObjects', ['saveOsObject', 'setDetailedOsObject']),

    cancel() {
      this.$router.push({ name: 'ServiceOrderObjects' });
    },
    async save() {
      this.$v.osObject.$touch();
      if (this.$v.osObject?.$error) return;

      try {
        this.setLoading(true);
        await this.saveOsObject(this.osObject);
        this.cancel();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
